// remove .no-js class on html element
	document.documentElement.className = document.documentElement.className.replace(/\bno-js\b/g, '') + ' js ';

  
// Smooth Scroll Animation
  var scroll = new SmoothScroll('a[href*="#"]');
  

// QTY Adjust

/* JS Quantity Incrementers */
jQuery(function(){
  var j = jQuery; 
  var addInput = '.js-qty-wrap'; 

  j(addInput).each(function() { 
    var inputEl = j(this).closest(addInput).find('input');
    var n = inputEl.val(); 
    var plusEl = j(this).closest(addInput).find('.plus');
    var minEl = j(this).closest(addInput).find('.min');
    //On plus click add 1 to n
    plusEl.on('click', function(){
      inputEl.val(++n);
    });
    //On min click 
    minEl.on('click', function(){
    //If n is bigger or equal to 1 subtract 1 from n 
      if ( ( inputEl.val() ) >= 1) {
        inputEl.val(--n);
      } 
    });
  });
});
  


//.js-success-stories
document.querySelectorAll('.js-success-stories').forEach(slider => {
    tns({
    container: slider,
    items: 1,
    "nav":true,
  	"navPosition":"bottom",
    responsive: {
      768: {
        gutter: 20,
        items: 2
      },
      992: {
        items: 3
      },
      1200: {
        gutter: 30
      }
    }
  });
});

//.js-success-stories

document.querySelectorAll('.js-carousel').forEach(slider => {
    tns({
    container: slider,
    items: 1,
    responsive: {
      640: {
        edgePadding: 20,
        gutter: 20,
        items: 2
      },
      769: {
         items: 2,
          "arrowKeys": true,
  		"nav":true,
  		"navPosition":"bottom"
      },
      1025: {
        items: 3
      },
       1201: {
        items: 4
      },
       1351: {
        items: 5
      },
       1651: {
        items: 6
      }
    }
  });
});

// TOUR CAROUSEL

document.querySelectorAll('.js-tour').forEach(slider => {
    tns({
    container: slider,
  "items": 1,
  "slideBy": "page",
  "mouseDrag": true,
  "swipeAngle": false,
  "speed": 400,
  "arrowKeys": true,
  "nav":true,
  "navPosition":"bottom"
  });
});




// ORDER REVIEWS CAROUSEL

document.querySelectorAll('.js-order-reviews').forEach(slider => {
    tns({
      container: slider,
      items: 1,
      "slideBy": "page",
      "mouseDrag": true,
      "swipeAngle": false,
      "speed": 400,
      "arrowKeys": true,
      "controls":false,
      "nav":true,
      "navPosition":"bottom",
    responsive: {

      769: {items: 2}
    
    }
  });
});

// HOME VIDEOS CAROUSEL

document.querySelectorAll('.js-home-videos').forEach(slider => {
    tns({
      container: slider,
      items: 3,
      "slideBy": "page",
      "mouseDrag": true,
      "swipeAngle": false,
      "speed": 400,
      "arrowKeys": true,
      "controls":false,
      "nav":true,
      "navPosition":"bottom",
      responsive: {

      769: {items: 3}
    
    }
  });
});

// PLANS CAROUSEL

document.querySelectorAll('.js-plans').forEach(slider => {
    tns({
    container: slider,
  "items": 1,
  "slideBy": "page",
  "mouseDrag": true,
  "swipeAngle": false,
  "speed": 400,
  "arrowKeys": true,
  "nav":false
  });
});



// BLOG HOME CAROUSEL

document.querySelectorAll('.blog-home').forEach(slider => {
  tns({
  container: slider,
    "items": 1,
    "slideBy": "page",
    "mouseDrag": true,
    "swipeAngle": false,
    "speed": 400,
    "arrowKeys": true,
    "nav":true,
    "navPosition":"bottom",
  });
});



// Athetes CAROUSEL

document.querySelectorAll('.js-athletes').forEach(slider => {
    tns({
    container: slider,
  "items": 1,
  "slideBy": "page",
  "mouseDrag": true,
  "swipeAngle": false,
  "speed": 400,
  "arrowKeys": false,
  "nav":true,
  "navPosition":"bottom",
	responsive: {
      640: {
        "arrowKeys": false,
      },
      700: {
         "arrowKeys": true,
      },
      900: {
          "arrowKeys": true,
      }
    }
  });
});



// FOUNERS CAROUSEL
document.querySelectorAll('.js-founders').forEach(slider => {
    tns({
    container: slider,
  "items": 1,
  "slideBy": "page",
  "mouseDrag": true,
  "swipeAngle": false,
  "speed": 400,
  "arrowKeys": false,
  "nav":true,
  "navPosition":"bottom",
  "mode":"gallery"
  });
});



//HAMBURGER

(function() {

  "use strict";

  var toggles = document.querySelectorAll(".c-hamburger");

  for (var i = toggles.length - 1; i >= 0; i--) {
    var toggle = toggles[i];
    toggleHandler(toggle);
  };

  function toggleHandler(toggle) {
    toggle.addEventListener( "click", function(e) {
      e.preventDefault();
      (this.classList.contains("is-active") === true) ? this.classList.remove("is-active") : this.classList.add("is-active");
    });
  }

})();
